import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=aab12bfc&"
import script from "./EventItem.vue?vue&type=script&lang=js&"
export * from "./EventItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab12bfc')) {
      api.createRecord('aab12bfc', component.options)
    } else {
      api.reload('aab12bfc', component.options)
    }
    module.hot.accept("./EventItem.vue?vue&type=template&id=aab12bfc&", function () {
      api.rerender('aab12bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/EventItem.vue"
export default component.exports